import { apiFetch, apiRequest } from './client';
function studyTagsPath(studyId) {
    return `/studies/${encodeURIComponent(studyId)}/tags`;
}
export async function getStudyTagLinks(studyId) {
    const response = await apiFetch(studyTagsPath(studyId));
    return response.links;
}
/** Replace the study's whole tag set; returns the canonical set (newTag rows
 * resolved to their tag ids). */
export async function putStudyTagLinks(studyId, links) {
    const response = await apiRequest('PUT', studyTagsPath(studyId), {
        links,
    });
    return response.links;
}
